async function parse<T>(res: Response): Promise<T> {
  const json = await res.json();
  if (!res.ok) {
    throw new Error(json?.error?.message || json?.error?.code || 'Request failed');
  }
  return json.data as T;
}

export const api = {
  get: <T,>(path: string) => fetch(path).then(r => parse<T>(r)),
  post: <T,>(path: string, body?: unknown) =>
    fetch(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
    }).then(r => parse<T>(r)),
  patch: <T,>(path: string, body?: unknown) =>
    fetch(path, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
    }).then(r => parse<T>(r)),
  del: <T,>(path: string) => fetch(path, { method: 'DELETE' }).then(r => parse<T>(r)),
};
